import { useFormContext } from '@calendly/form'
import { useMemo } from 'react'

import { INTEGRATIONS, PHONE_CALL_KINDS } from 'components/event_type_edit/location_v3/constants'
import { useLocationManagement, useOrganizer } from 'components/event_type_edit/location_v3/hooks'
import {
  extractIntegrationsStatus,
  getMembershipIntegrationStatus,
} from 'components/event_type_edit/location_v3/utils'

import { CustomLocationItem } from './custom_location_item'
import { PhoneCallItem } from './phone_call_item'
import { PhysicalLocationItem } from './physical_location_item'
import { SelectedLocationRow } from './selected_location_row'

const PHONE_KINDS = [PHONE_CALL_KINDS.outbound, PHONE_CALL_KINDS.inbound]

export const SelectedLocationItem = ({
  location,
  membership,
  eventType,
  shouldDisableOutbound,
  isReadOnly,
  isDisabled,
  showIntegrationErrors = false,
}) => {
  const { removeLocation, fieldNamePrefix } = useLocationManagement(eventType, membership, location)
  const { values: { locationConfigurations = [] } } = useFormContext()
  const { currentOrganizer } = useOrganizer(eventType, location.kind, locationConfigurations)
  const integrationStatuses = useMemo(
    () => extractIntegrationsStatus(eventType, currentOrganizer),
    [eventType, currentOrganizer]
  )
  const hasIntegrationError = INTEGRATIONS.includes(location.kind) && !integrationStatuses[location.kind]
  const organizerHasIntegrationError = getMembershipIntegrationStatus(currentOrganizer, location.kind)
  const showIntegrationError = showIntegrationErrors && (hasIntegrationError || organizerHasIntegrationError)

  if (location.kind === 'physical') {
    return (
      <PhysicalLocationItem
        location={location}
        fieldNamePrefix={fieldNamePrefix}
        removeLocation={removeLocation}
        isReadOnly={isReadOnly}
        isDisabled={isDisabled}
      />
    )
  }

  if (location.kind === 'custom') {
    return (
      <CustomLocationItem
        location={location}
        fieldNamePrefix={fieldNamePrefix}
        removeLocation={removeLocation}
        isReadOnly={isReadOnly}
        isDisabled={isDisabled}
      />
    )
  }

  if (location.kind === null || PHONE_KINDS.includes(location.kind)) {
    return (
      <PhoneCallItem
        location={location}
        fieldNamePrefix={fieldNamePrefix}
        removeLocation={removeLocation}
        shouldDisableOutbound={shouldDisableOutbound}
        isReadOnly={isReadOnly}
        isDisabled={isDisabled}
      />
    )
  }

  return (
    <SelectedLocationRow
      kind={location.kind}
      onRemove={removeLocation}
      isReadOnly={isReadOnly}
      isDisabled={isDisabled}
      showIntegrationError={showIntegrationError}
    />
  )
}
